import { saveAs } from "file-saver"
import Papa from "papaparse"
import { formatInboundCsvValue } from "@/components/InboundTransportOrder/CSVExport/inboundCsvFormatting"

export type InboundCsvHeader<Row extends object> = {
    key: keyof Row
    label: string
}

export const serializeInboundCsv = <Row extends object>(
    rows: Row[],
    headers: InboundCsvHeader<Row>[],
): string => {
    const fields = headers.map(header => header.label)
    const data = rows.map(row =>
        headers.map(header =>
            formatInboundCsvValue(row[header.key]) ?? ""
        )
    )
    return `\uFEFF${Papa.unparse(
        { fields, data },
        {
            delimiter: ",",
            newline: "\n",
            quotes: true,
            escapeFormulae: /^[=+\-@\t\r]/,
        },
    )}`
}

export const downloadInboundCsv = <Row extends object>(
    rows: Row[],
    headers: InboundCsvHeader<Row>[],
    filename: string,
): void => {
    const csv = serializeInboundCsv(rows, headers)
    saveAs(new Blob([csv], { type: "text/csv;charset=utf-8" }), filename)
}
